
import { reduceFileAccept } from '@/common/file';
import { v2Host } from '@/config/host';
import { getApiPath } from '@/common/api-proxy.js';

export default {
  props: {
    tips: {
      type: String,
      default: ''
    },
    coverSize: {
      type: Object,
      default: {
        height: 140,
        width: 140
      }
    },
    previewUrl: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      uploadFileUrl: '' + v2Host + getApiPath('/upload/file'),
      accept: reduceFileAccept(['png', 'jpg']),
      uploadList: []
    };
  },
  mounted: function mounted() {
    if (this.previewUrl) {
      this.uploadList = [{
        url: this.previewUrl,
        name: 'default'
      }];
    }
  },
  destroyed: function destroyed() {
    this.uploadList = [];
  },


  methods: {
    handleUploadSuccess: function handleUploadSuccess(res, file, fileList) {
      if (Number(res.code) === 0) {
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }
        this.$emit('on-success', res, file);
      } else {
        this.handleUploadError(res);
      }
    },
    handleUploadError: function handleUploadError(res) {
      this.$emit('on-error', res);
      this.promptUploadError(res.msg);
    },
    promptUploadError: function promptUploadError(msg) {
      this.$message({ message: msg || '上传失败', type: 'error' });
    }
  }
};